import { CommitteeManagementPageContent } from ".";

export default function ActiveCommitteesPage() {
  return <CommitteeManagementPageContent activeTab="active" />;
}
